import axios from 'axios'
import store from '@/store'
const querystring = require("querystring");
var isRereshingToken = false
//挂起的请求
var refreshSubscribers = []

//更新所有挂起请求的旧token,并激活
var onRrefreshed = function (token) {
    refreshSubscribers.map(cb => {
        cb(token)
    })
}

//授权
var viliToken = function (config) {
    const identity = store.getters.getToken();

    if (typeof identity.access_token == "undefined")
        return config;

    config.headers['Content-Type'] = 'application/json';

    //判断是否过期
    var dt = new Date()
    if (identity.expires_in - dt.getTime() > 0) {
        config.headers.Authorization = identity.token_type + ' ' + identity.access_token
        return config;
    } else {
        //先挂起请求
        let retry = new Promise((resolve, reject) => {
            refreshSubscribers.push((token) => {
                config.headers.Authorization = identity.token_type + ' ' + token
                //放行请求
                resolve(config)
            })
        })
        
        //刷新token
        refreshToken(identity.refresh_token)

        return retry
    }
}

//刷新token
var refreshToken = function (refresh_token) {
    const data = querystring.stringify({
        client_id: process.env.IDENTITY_KEY,
        client_secret: process.env.IDENTITY_VALUES,
        grant_type: "refresh_token",
        refresh_token: refresh_token
    });
    if (!isRereshingToken) {
        isRereshingToken = true;
        var post = axios.post("connect/token", data, {
            baseURL: process.env.IDENTITY_BASE_API,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        post.then((response) => {
            store.commit(store.state.mutatinTypes.SET_TOKEN, response.data);
            onRrefreshed(response.data.access_token)
            refreshSubscribers = []
            isRereshingToken = false;
        }).catch((error) => {
            store.commit(store.state.mutatinTypes.LOGIN_OUT);
        });
    }
}

const instance = axios.create({
    baseURL: process.env.BUSS_BASE_API,
    timeout: 3000
});

instance.interceptors.request.use(
    config => {
        var config = viliToken(config);
        return config;
    },
    error => {
        Promise.reject(error)
    }
)

instance.interceptors.response.use(
    //success
    function (response) {
        return response;
    },
    //error
    function (error) {
        if (error.response.status == 401 || error.response.statusText.toLowerCase() == "unauthorized") {
            const identity = store.getters.getToken();
            if (typeof identity.access_token == "undefined") {
                store.commit(store.state.mutatinTypes.LOGIN_OUT);
            } else {
                //刷新token
                refreshToken(identity.refresh_token)
            }
            return Promise.reject(error);
        }
        return Promise.reject(error);
    });


export default instance


